<script setup lang="ts">
import { getCurrentLocale } from '@/i18n';
const currentLanguage = getCurrentLocale();
const routerLink = `https://vacations.aircanada.com/${currentLanguage}`;

const handleRedirectLink = (link) => {
  location.href = link;
};
</script>
<template>
  <div class="grid error-page">
    <div>
      <h1>{{ $t('error_page.error_occurr') }}</h1>
      <div class="error-text">
        <p>{{ $t('error_page.cannot_complete') }}</p>
      </div>
      <div class="btn-container">
        <div class="return-homepage">
          <div id="btn-home" class="btn-error" @click="handleRedirectLink(routerLink)">{{ $t('error_page.return_button') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '@/assets/scss/themes/acv-default/default-includes.scss';
@use '@/assets/scss/themes/acv-default/default-mixins' as *;

.error-page {
  background-image: url(/assets/images/outage_page.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 80px 0 0 60px;
  height: 100dvh;
  margin: 0;

  @media (max-width: 767px) {
    padding: 80px 30px 0 30px;
  }

  .error-sub-title {
    font-size: 28px;
    line-height: 32px;
    letter-spacing: normal;
    color: #e7201d;
  }
  .error-text {
    text-wrap: balance;
  }

  .return-homepage {
    margin-top: 20px;

    .btn-error {
      display: inline-flex;
      min-width: 110px;
      min-height: 40px;
      justify-content: center;
      align-items: center;
      margin: 0;
      padding: 0 15px;
      font-size: 16px;
      font-family: 'SharpGroteskMedium19', Arial, Verdana, Helvetica, sans-serif;
      font-weight: normal;
      line-height: 1.2;
      color: white;
      text-transform: uppercase;
      text-align: center;
      letter-spacing: 0.2px;
      text-decoration: none;
      background-color: #026283;
      border: none;
      border-radius: 5px;
      -webkit-appearance: none;
      -moz-appearance: none;
      cursor: pointer;

      &:hover,
      &:focus {
        color: white;
        background-color: #00526e;
      }
    }
  }
}
</style>
